import { useHRApi } from "@/api/useHRApi";
import { ModalName } from "@/components/Modal/modal-name";
import { useModal } from "@/composables/useModal";
import { useWalletCollectionStore } from "@/store/wallet-collection";
import { useWeb3Store } from "@/store/web3";
import { web3 } from "@/web3";
import { ref } from "vue";
import { Config } from "@/config";
import { useMethBankStore } from "@/store/meth-bank";
export const harvestMeth = async () => {
  try {
    const methMakerIds = [];
    let teenIds = [];
    let allTeenIds = [];
    const web3Store = useWeb3Store();
    const walletCollectionStore = useWalletCollectionStore();
    let walletAddress = web3Store.collectionWallet;

    const methMachines = walletCollectionStore.methMachines;
    const uniquemethMachines = methMachines.filter((item, index) => {
      return (
        methMachines.findIndex((maker) => maker.guild === item.guild) === index
      );
    });

    uniquemethMachines.forEach((methMaker) => {
      const teens = walletCollectionStore.teens
        .filter((item) => {
          return item.guild === methMaker.guild && !item.isResurrected;
        })
        .map((teen) => teen.id + "");
      if (!teens.length) return;
      teenIds = teenIds.concat(teens);
      methMakerIds.push(methMaker.id + "");
    });
    allTeenIds = walletCollectionStore.teens
      .filter((teen) => !teenIds.includes(teen.id + "") && !teen.isResurrected)
      .map((teen) => teen.id + "");
    let botbTokens = {};
    const { botbOG, botbBears, botbEVO, partners } = walletCollectionStore;
    if (botbOG.length) {
      botbTokens[Config.BOTBAddress.OG] = botbOG.map((token) => token.id + "");
    }
    if (botbBears.length) {
      botbTokens[Config.BOTBAddress.Bears] = botbBears.map(
        (token) => token.id + ""
      );
    }
    if (botbEVO.length) {
      botbTokens[Config.BOTBAddress.EVO] = botbEVO.map(
        (token) => token.id + ""
      );
    }

    let partner_tokens = {};
    const partnersTokens = partners;
    if (partnersTokens && Object.keys(partnersTokens).length) {
      Object.keys(partnersTokens).forEach((key) => {
        let partnerAddress = partnersTokens[key][0].token_address;
        let checksummedAddress = web3.utils.toChecksumAddress(partnerAddress);
        partner_tokens[checksummedAddress] = partnersTokens[key]
          .map((token) => {
            const address = web3.utils.toChecksumAddress(token.token_address);
            if (address !== checksummedAddress) {
              if (!partner_tokens[address]) {
                partner_tokens[address] = [];
              }
              partner_tokens[address].push(token.id + "");
            } else {
              return token.id + "";
            }
          })
          .filter((item) => item !== undefined);
      });
    }
    const { open: openModal } = useModal();
    const modalProps = ref({
      totalAssets: 0,
      pendingHarvests: 0,
      isHarvested: false,
    });
    openModal({
      name: ModalName.HarvestModal,
      closeOnOverlay: false,
      props: modalProps,
    });
    const harvestData = await useHRApi({
      throw: true,
      toast: { error: true },
    }).exec({
      url: "/v1/bap/harvest-meth",
      method: "POST",
      data: {
        wallet_address: walletAddress,
        meth_maker_ids: methMakerIds,
        teen_ids: teenIds,
        all_teen_ids: allTeenIds,
        network: Config.network.name,
        partner_tokens:
          Config.network.name === "mainnet"
            ? { ...botbTokens, ...partner_tokens }
            : undefined,
        version: Config.mode !== "production" ? 2 : undefined,
      },
    });
    const totalAssets = harvestData.harvest_ids.length;

    const poll = async () => {
      try {
        const data = await useHRApi().exec({
          url: `/v1/bap/harvest-status`,
          params: {
            wallet_address: walletAddress,
          },
        });
        const pendingHarvests = data.pending_harvests;
        console.log("polling", data);

        modalProps.value = {
          harvestTotal: totalAssets,
          harvestPending: pendingHarvests,
        };

        if (pendingHarvests <= 0) {
          return;
        }
        await new Promise((resolve) => {
          setTimeout(resolve, 1000);
        });
        await poll();
      } catch (err) {
        console.log("error while polling", err);
      }
    };
    await poll();
    modalProps.value = { ...modalProps.value, isHarvested: true };
    await Promise.all([
      walletCollectionStore.fetchCollection(true),
      useMethBankStore().fetchMethBank(),
    ]);
  } catch (err) {
    console.log(err);
    useModal().close();
  }
};
